import React, { useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import PlayerSidebar from '../../components/Dashboard/Sidebar';
import { AuthContext } from '../../context/AuthContext';
import Swal from 'sweetalert2';
import { FaBars } from 'react-icons/fa';

const PlayerLayout = () => {
    const { logout } = useContext(AuthContext);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = () => {
        Swal.fire({
            title: 'Are you sure you want to log out?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, log out'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await logout();
            }
        });
    };

    return (
        <div className="flex flex-col md:flex-row bg-slate-100 min-h-screen">
            {/* Mobile Header Bar */}
            <div className="md:hidden bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between shadow-xs sticky top-0 z-30">
                <div className="flex items-center gap-2.5">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="p-2 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 transition"
                        aria-label="Open sidebar menu"
                    >
                        <FaBars className="text-base" />
                    </button>
                    <div className="flex items-center gap-2">
                        <img
                            src="/assets/parasports.png"
                            alt="Logo"
                            className="w-7 h-7 object-contain"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/images/parasports.png";
                            }}
                        />
                        <span className="font-extrabold text-sm text-slate-800">Player Portal</span>
                    </div>
                </div>
            </div>

            {/* Sidebar (drawer on mobile, fixed column on desktop) */}
            <PlayerSidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                onLogout={handleLogout}
            />
            
            {/* Main Content Area */}
            <main className="flex-grow p-3.5 sm:p-5 md:p-8 min-w-0 max-w-full overflow-x-hidden">
                <Outlet />
            </main>
        </div>
    );
};

export default PlayerLayout;
